import Vue from 'vue';
import 'bootstrap';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import es from 'vee-validate/dist/locale/es';
import VeeValidate, { Validator } from 'vee-validate';
import 'leaflet/dist/leaflet.css';
import router from './_router';
import store from './_store';
import App from './App.vue';
import './layouts';
import './components';

library.add(fas);
library.add(far);
library.add(fab);
Vue.component('fa-icon', FontAwesomeIcon);


const moment = require('moment-timezone');

moment.locale('es');
Vue.prototype.$moment = moment;

Vue.config.productionTip = false;

Vue.use(VeeValidate);

// Localize takes the locale object as the second argument (optional) and merges it.
Validator.localize('es', es);

const rneValidator = (value) => {
    // Primera letra de su nombre
    // Primera letra del primer apellido
    // Primera letra del segundo apellido
    // Año de nacimiento (aaaa)
    // Mes de nacimiento (mm)
    // Día de nacimiento (dd)
    // Mas cuatro ceros (0000)
    const re = /^[A-Z]{3}(\d{4})(\d{2})(\d{2})0{4}$/;
    const valid = re.test(value);
    const validDate = new Date(value.replace(re, '$2/$3/$1')).toString() !== 'Invalid Date';
    return valid && validDate;
};

Validator.extend('rne', {
    getMessage: () => 'Introduzca un RNE válido.',
    validate: rneValidator,
});

Vue.filter('capitalize', (value) => {
    if (!value) return '';
    const aux = value.toString().toLowerCase();
    return aux.charAt(0).toUpperCase() + aux.slice(1);
});

Vue.filter('lowercase', (value) => {
    if (!value) return '';
    const aux = value.toString();
    return aux.toLowerCase();
});

Vue.filter('number', (value) => {
    if (!value) return '';
    const formatter = new Intl.NumberFormat();
    const aux = formatter.format(value.toString());
    return aux.replace(',', '.');
});

Vue.filter('currency', (value) => {
    if (!value) return '';
    const formatter = new Intl.NumberFormat('en-US');
    const aux = formatter.format(value.toString());
    return aux;
});

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
